import { renderApp } from '@wrisk/web-app'
import { wriskTheme } from '@wrisk/wrisk-theme'

import { translations } from './translations'

renderApp('app', wriskTheme, translations)
